/* @generated from adl */
import { declResolver, ScopedDecl } from "./runtime/adl";
import { _AST_MAP as common } from "./common";
import { _AST_MAP as common_config_aws } from "./common/config/aws";
import { _AST_MAP as common_config_db } from "./common/config/db";
import { _AST_MAP as common_config_emailer } from "./common/config/emailer";
import { _AST_MAP as common_config_google } from "./common/config/google";
import { _AST_MAP as common_config_jwt } from "./common/config/jwt";
import { _AST_MAP as common_config_log } from "./common/config/log";
import { _AST_MAP as common_config_server } from "./common/config/server";
import { _AST_MAP as common_db } from "./common/db";
import { _AST_MAP as common_http } from "./common/http";
import { _AST_MAP as common_strings } from "./common/strings";
import { _AST_MAP as common_tabular } from "./common/tabular";
import { _AST_MAP as common_ui } from "./common/ui";
import { _AST_MAP as sys_adlast } from "./sys/adlast";
import { _AST_MAP as sys_annotations } from "./sys/annotations";
import { _AST_MAP as sys_dynamic } from "./sys/dynamic";
import { _AST_MAP as sys_types } from "./sys/types";
import { _AST_MAP as totalinteraction_futurefit_db } from "./totalinteraction/futurefit/db";
import { _AST_MAP as totalinteraction_futurefit_db_learningevent } from "./totalinteraction/futurefit/db/learningevent";
import { _AST_MAP as totalinteraction_futurefit_db_scodlemigration } from "./totalinteraction/futurefit/db/scodlemigration";
import { _AST_MAP as totalinteraction_futurefit_frontend } from "./totalinteraction/futurefit/frontend";
import { _AST_MAP as totalinteraction_futurefit_lpapi } from "./totalinteraction/futurefit/lpapi";
import { _AST_MAP as totalinteraction_futurefit_lpapirequests } from "./totalinteraction/futurefit/lpapirequests";
import { _AST_MAP as totalinteraction_futurefit_requests } from "./totalinteraction/futurefit/requests";
import { _AST_MAP as totalinteraction_futurefit_uiconfig } from "./totalinteraction/futurefit/uiconfig";

export const ADL: { [key: string]: ScopedDecl } = {
  ...common,
  ...common_config_aws,
  ...common_config_db,
  ...common_config_emailer,
  ...common_config_google,
  ...common_config_jwt,
  ...common_config_log,
  ...common_config_server,
  ...common_db,
  ...common_http,
  ...common_strings,
  ...common_tabular,
  ...common_ui,
  ...sys_adlast,
  ...sys_annotations,
  ...sys_dynamic,
  ...sys_types,
  ...totalinteraction_futurefit_db,
  ...totalinteraction_futurefit_db_learningevent,
  ...totalinteraction_futurefit_db_scodlemigration,
  ...totalinteraction_futurefit_frontend,
  ...totalinteraction_futurefit_lpapi,
  ...totalinteraction_futurefit_lpapirequests,
  ...totalinteraction_futurefit_requests,
  ...totalinteraction_futurefit_uiconfig,
};

export const RESOLVER = declResolver(ADL);



// WEBPACK FOOTER //
// ./src/adl-gen/resolver.ts